export default "__VITE_ASSET__Y2OkICvq__"